<template>
  <div class="h-full w-full bg-yellow-100 flex flex-col justify-center items-center p-6 shadow-inner">
      <div class="relative h-12 w-full">
          <img src="@/assets/images/box.svg" class="object-contain h-full w-full absolute inset-0" alt="name">
      </div>
      <div class="text-center text-sm text-primary font-semibold uppercase mt-3">{{ name }}</div>
  </div>
</template>

<script>
export default {
    name: "CatererLogoPlaceholder",
    props: {
        name: String
    }
}
</script>